export default "__VITE_ASSET__BqD1Delg__"